const Footer = () => {
  return (
    <footer className="footer">
      <div className="d-sm-flex justify-content-center">
        <p className="mb-0">
          Copyright © 2023{" "}
          <a
            rel="noreferrer"
            style={{ textDecorationLine: "underline !important" }}
            href="https://scandiautomation.com/"
            target="_blank"
          >
            Scandi Automation
          </a>
          .
        </p>
      </div>
    </footer>
  );
};

export default Footer;
